import {
  TransactionLayout
} from 'common/types/globalTypes';

export const isLayoutPaycycle = (layoutType: TransactionLayout) => {
  switch (layoutType) {
    case 'CHECK_PAYMENT':
    case 'WIRE_PAYMENT':
    case 'SERVICE_PAYMENT':
    case 'ACH_PAYMENT':
      return true;
    default:
      return false;
  }
};
export const isVendorLink = (layoutType: TransactionLayout) => {
  return !(
    layoutType === 'PO_SYSTEM_APPROVAL' ||
    layoutType === 'PO_SYSTEM_APPROVAL_ACCOUNTING' ||
    layoutType === 'TA_SYSTEM_APPROVAL' ||
    layoutType === 'BATCH_TRANSACTION_APPROVAL' ||
    layoutType === 'MISCELLANEOUS_APPROVAL' ||
    isLayoutPaycycle(layoutType)
  );
};

export const getApprovalOrderBy = (layoutType: string | null | undefined) => {
  switch (layoutType) {
    case 'BATCH_TRANSACTION_APPROVAL':
      return ['ITEM_DESCRIPTION_5_ASC'];
    case 'PO_SYSTEM_APPROVAL':
      return [
        'REFERENCE_CODE_1_ASC',
        'ITEM_DESCRIPTION_3_ASC',
        'ITEM_UNIT_1_ASC',
        'ITEM_DESCRIPTION_1_ASC',
        'ITEM_DESCRIPTION_2_ASC',
      ];
    case 'TA_SYSTEM_APPROVAL':
      return [
        'ITEM_DESCRIPTION_2_ASC',
        'ITEM_DESCRIPTION_1_ASC',
      ];
    case 'AP_INVOICE':
      return ['_CREATED_DATE_ASC'];
    case 'PO_SYSTEM_APPROVAL_ACCOUNTING':
      return ['ITEM_UNIT_2_ASC'];
    default:
      return [
        'ITEM_DESCRIPTION_3_ASC',
        'ITEM_UNIT_1_ASC',
        'ITEM_DESCRIPTION_1_ASC',
        'ITEM_DESCRIPTION_2_ASC',
      ];
  }
};
